import React from 'react';

import constants from '../../utils/constants';

const ThreeStep = () => {
  const { KabbageSimple, loanLimit, LoanLimitStyled } = constants;

  return (
    <section className="three-step med-hi emerald">
      <div className="container ways-to-fund">
        <h2 className="h1-style">
          There&#39;s a better way to fund your business
        </h2>
        <div className="two-column">
          <div className="column two-thirds">
            <p>
              {`Accessing small business funding shouldn't be complicated or
              time-consuming, so `}
              <KabbageSimple />
              {` developed a simple way to get up to ${loanLimit}.`}
              <sup>2</sup>
            </p>
          </div>
          <div className="column one-third">
            <a
              href="https://www.youtube.com/watch?v=MbJIdUFbY18"
              className="pill-button medium video-link"
            >
              <i className="fa fa-play" aria-hidden="true" /> Watch video
            </a>
          </div>
        </div>
        <div className="three-column flex clearfix">
          <div className="column">
            <div className="ways way-one">
              <span className="small">up to a</span>
              {LoanLimitStyled}
              <span className="small">
                line of credit<sup>*</sup>
              </span>
            </div>
          </div>
          <div className="column">
            <div className="ways way-two">
              <span className="small">qualify in</span>
              <span className="larger">
                <span>10</span>
              </span>
              <span className="small">
                minutes<sup>2</sup>
              </span>
            </div>
          </div>
          <div className="column">
            <div className="ways way-three">
              <span className="small">choose </span>
              <span className="larger">
                <span className="month">6,</span>{' '}
                <span className="month">12</span>
                {' or '}
                <span className="month">18</span>
              </span>
              <span className="small">
                month terms<sup>1,3</sup>
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ThreeStep;
